import { render, staticRenderFns } from "./TabHeaderCustomerId.vue?vue&type=template&id=971e09ac"
import script from "./TabHeaderCustomerId.vue?vue&type=script&lang=js"
export * from "./TabHeaderCustomerId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports